var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "index-brief" },
    [
      _vm.loading
        ? _c("div", { staticClass: "brief-loading" }, [
            _c("img", {
              attrs: {
                src: require("../../assets/images/gif-loading.gif"),
                alt: "loading"
              }
            })
          ])
        : [
            _vm.ordinaryDisplay
              ? _c(
                  "div",
                  { staticClass: "index-compare row mb-2 h5 font-weight-bold" },
                  [
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _vm._v(_vm._s(_vm.indexCompare.title) + "：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _c("span", { staticClass: "number" }, [
                        _vm._v(_vm._s(_vm.indexCompareValueKSep))
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.noTownValue
              ? _c(
                  "div",
                  { staticClass: "index-compare row mb-2 h5 font-weight-bold" },
                  [
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _vm._v(
                        "（" +
                          _vm._s(_vm.location.countyname) +
                          "之）" +
                          _vm._s(_vm.indexCompare.title) +
                          "："
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _c("span", { staticClass: "number" }, [
                        _vm._v(_vm._s(_vm.indexCompareValueKSep))
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _vm.hasTownValueAndNotCounty
              ? _c(
                  "div",
                  { staticClass: "index-rank row mb-2 h5 font-weight-bold" },
                  [
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _vm._v(_vm._s(_vm.indexCompare.title) + "於縣市排名：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.townIndexRankInCounty) +
                            " / " +
                            _vm._s(_vm.townNumberInCounty)
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.ordinaryDisplay
              ? _c(
                  "div",
                  { staticClass: "index-rank row mb-2 h5 font-weight-bold" },
                  [
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _vm._v(_vm._s(_vm.indexCompare.title) + "於全國排名：")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.indexNationalRank) +
                            " / " +
                            _vm._s(_vm.totalTownNumbers)
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.noTownValue
              ? _c(
                  "div",
                  { staticClass: "index-rank row mb-2 h5 font-weight-bold" },
                  [
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _vm._v(
                        "（" +
                          _vm._s(_vm.location.countyname) +
                          "之）" +
                          _vm._s(_vm.indexCompare.title) +
                          "於全國排名："
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-auto" }, [
                      _c("span", { staticClass: "number" }, [
                        _vm._v(
                          _vm._s(_vm.indexNationalRank) +
                            " / " +
                            _vm._s(_vm.totalTownNumbers)
                        )
                      ])
                    ])
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }